/**
  * vue-cal v5.0.1-rc.19
  * (c) 2024-2025 Antoni Andre <antoniandre.web@gmail.com>
  * @license MIT
  */
const t = ["Даваа", "Мягмар", "Лхавга", "Пүрэв", "Баасан", "Бямба", "Ням"], n = ["1-р сар", "2-р сар", "3-р сар", "4-р сар", "5-р сар", "6-р сар", "7-р сар", "8-р сар", "9-р сар", "10-р сар", "11-р сар", "12-р сар"], o = "Жилүүд", s = "Жил", e = "Сар", c = "Долоо хоног", a = "Өдрийн", d = "Өдөр", y = "Өнөөдөр", r = "Тэмдэглэлгүй", l = "Бүх өдөр", m = "Устгах", M = "Шинэ тэмдэглэл", Y = "dddd D MMMM YYYY", v = {
  weekDays: t,
  months: n,
  years: o,
  year: s,
  month: e,
  week: c,
  days: a,
  day: d,
  today: y,
  noEvent: r,
  allDay: l,
  deleteEvent: m,
  createEvent: M,
  dateFormat: Y
};
export {
  l as allDay,
  M as createEvent,
  Y as dateFormat,
  d as day,
  a as days,
  v as default,
  m as deleteEvent,
  e as month,
  n as months,
  r as noEvent,
  y as today,
  c as week,
  t as weekDays,
  s as year,
  o as years
};
